import React, { useState } from "react";
import {
  TextArea,
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { useStaticContext } from "../../context/StaticContext";
import { getOneAiChatInfo } from "../../lib/sysNavigation/SysNavigation";
import { FaRobot } from "react-icons/fa";

const Edit = () => {
  const { updateStaticContent } = useStaticContext();
  const ai_chat_info: any = getOneAiChatInfo();

  const [error, setError] = useState<any>(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<any>(false);

  const ai_chat_info_id = ai_chat_info.ai_chat_info_id;
  const [title, setTitle] = useState<any>(ai_chat_info.title);
  const [description, setDescription] = useState<any>(ai_chat_info.description);

  const ai_chat_infoRoutes = "/ai_chat_info";

  const responses = (error: any, message: any) => {
    setError(error);
    setSuccess(!error);
    setLoading(false);
    setErrorMessage(message);
  };

  const updateOneChatgetOneAiChatInfoHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  /**
   * @author Ntavigwa Bashombe
   * @param {*} thumbnail
   * @returns
   */
  const sendDBRequest = async () => {
    const data = {
      title: title,
      description: description,
    };

    const { status, message } = await updateStaticContent(
      "ai_chat_info",
      ai_chat_info_id,
      data
    );

    if (status === 200) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null);
    setSuccess(null);
  };

  return (
    <AddPageShell
      backRoute={ai_chat_infoRoutes}
      eyebrow="Settings • AI Chat Info"
      title="Edit AI Chat Info"
      subtitle="Configure the heading and description for the AI chat block."
      icon={<FaRobot className="h-5 w-5" />}
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneChatgetOneAiChatInfoHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Basic Information"
        hint="The title is shown as the AI chat section heading."
      >
        <InputField
          props={{
            id: "title",
            title: "Title",
            type: "text",
            value: title ? title : "",
            onChange: (e: any) => {
              setTitle(e.target.value);
              clearMessages();
            },
          }}
        />
      </AddSection>

      <AddSection
        title="Description"
        hint="A concise summary (aim for ~120 characters)."
      >
        <TextArea
          props={{
            id: "description",
            title: "",
            type: "text",
            value: description ? description : "",
            rows: 6,
            onChange: (e: any) => {
              setDescription(e.target.value);
              clearMessages();
            },
          }}
        />
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
